export default __webpack_public_path__ + "static/media/mp-3.c7daae5a.png";